import { UPDATE_ACCOUNT_SUCCESS } from './accountActionTypes';

export const updateAccountSuccess = payload => ({ type: UPDATE_ACCOUNT_SUCCESS, payload });
